"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const u = require("../globals/uris");
class BoundVariable {
    constructor(name) {
        this.name = name;
    }
    getName() {
        return this.name;
    }
    toString() {
        return '∀ ' + this.name;
    }
}
exports.BoundVariable = BoundVariable;
class TypedVariable extends BoundVariable {
    constructor(name, type) {
        super(name);
        this.type = type;
    }
    getType() {
        return this.type;
    }
    getValues(store) {
        return store.findSubjects(u.TYPE, this.type);
    }
    toString() {
        return super.toString() + ' : ' + this.type;
    }
}
exports.TypedVariable = TypedVariable;
class ExpressionVariable extends TypedVariable {
    constructor(name, type, ...typeExpressions) {
        super(name, type);
        this.typeExpressions = [];
        this.typeExpressions = typeExpressions;
    }
    getTypeExpressions() {
        return this.typeExpressions;
    }
    getValues(store) {
        let values = super.getValues(store);
        this.typeExpressions.forEach(e => values = values.filter(v => e.evaluate(this.createVarsObject(v), store)));
        return values;
    }
    createVarsObject(dymoUri) {
        let vars = {};
        vars[this.name] = dymoUri;
        return vars;
    }
    toString() {
        return super.toString() + ', ' + this.typeExpressions.map(e => e.toString()).join(', ');
    }
}
exports.ExpressionVariable = ExpressionVariable;
class SetBasedVariable extends BoundVariable {
    constructor(name, set) {
        super(name);
        this.set = set;
    }
    getSet() {
        return this.set;
    }
    getValues(store) {
        return this.set; //.filter(u => store.find(u));
    }
    toString() {
        return super.toString() + ' in ' + JSON.stringify(this.set);
    }
}
exports.SetBasedVariable = SetBasedVariable;



//////////////////
// WEBPACK FOOTER
// ./~/dymo-core/lib/model/variable.js
// module id = 645
// module chunks = 3